import {actionType, CartItem, initialStateType} from './src/contexts/CartReducer'
import {toast} from 'react-hot-toast'
import cart from './cart'
import alerts from './src/config/alerts.json'

// Basic dispatch function type that only handles plain actions
type BasicDispatch = (action: actionType) => void

// Define the AppThunk type to match how it's used in CartContext.tsx
type AppThunk = (
  dispatch: BasicDispatch,
  state: initialStateType,
) => Promise<void>

export const fetchCart = (): AppThunk => async (dispatch, state) => {
  const uuid = state.uuid
  if (!uuid) return
  const cartData = await cart.fetchCart(uuid)
  dispatch({type: 'SET_CART', payload: cartData})
}

export const addItem =
  (item: CartItem): AppThunk =>
  async (dispatch, state) => {
    const uuid = state.uuid
    if (!uuid) return
    await cart.addToCart(uuid, item)
    const cart_state = await cart.fetchCart(uuid)
    dispatch({
      type: 'SET_CART',
      payload: cart_state,
    })
  }

export const updateItem =
  (item: CartItem): AppThunk =>
  async (dispatch, state) => {
    const uuid = state.uuid
    if (!uuid) return
    await cart.updateCartItem(uuid, item)
    const cart_state = await cart.fetchCart(uuid)
    dispatch({
      type: 'SET_CART',
      payload: cart_state,
    })
  }

export const linkUser = (): AppThunk => async (dispatch, state) => {
  const uuid = state.uuid
  if (!uuid) return
  await cart.linkUser(uuid)

  const cart_state = await cart.fetchCart(uuid)
  dispatch({
    type: 'SET_CART',
    payload: cart_state,
  })
}

export const removeItem =
  (itemId: string): AppThunk =>
  async (dispatch, state) => {
    const uuid = state.uuid
    if (!uuid) return
    await cart.removeCartItem(uuid, itemId)
    const cart_state = await cart.fetchCart(uuid)
    dispatch({
      type: 'SET_CART',
      payload: cart_state,
    })
  }

export const updateAddress =
  (address: any): AppThunk =>
  async (dispatch, state) => {
    const uuid = state.uuid
    if (!uuid) return

    try {
      const toastId = toast.loading('Updating Address')
      await cart.updateAddress(uuid, address)
      const cart_state = await cart.fetchCart(uuid)
      toast.dismiss(toastId)
      toast.success(alerts.cart_address_add)
      dispatch({
        type: 'SET_CART',
        payload: cart_state,
      })
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Something went wrong.')
    }
  }

export const updateAddressType =
  (address_type: 'pickup_point' | 'home_delivery' | 'self_pickup'): AppThunk =>
  async (dispatch, state) => {
    const uuid = state.uuid
    if (!uuid) return
    await cart.updateAddressType(uuid, address_type)
    const cart_state = await cart.fetchCart(uuid)
    dispatch({
      type: 'SET_CART',
      payload: cart_state,
    })
  }

export const applyCoupon =
  (coupon: string): AppThunk =>
  async (dispatch, state) => {
    const uuid = state.uuid
    if (!uuid) return
    try {
      await cart.applyCoupon(uuid, coupon)
      const cart_state = await cart.fetchCart(uuid)
      dispatch({
        type: 'SET_CART',
        payload: cart_state,
      })
      toast.success(alerts.coupon_added)
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Something went wrong.')
    }
  }

export const removeCoupon = (): AppThunk => async (dispatch, state) => {
  const uuid = state.uuid
  if (!uuid) return
  await cart.removeCoupon(uuid)
  const cart_state = await cart.fetchCart(uuid)

  toast.success(alerts.coupon_removed)

  dispatch({
    type: 'SET_CART',
    payload: cart_state,
  })
}

export const updateShipping =
  (shippingFee: number): AppThunk =>
  async (dispatch, state) => {
    const uuid = state.uuid
    if (!uuid) return
    await cart.updateShipping(uuid, shippingFee)
    const cart_state = await cart.fetchCart(uuid)
    dispatch({
      type: 'SET_CART',
      payload: cart_state,
    })
  }

export const emptyCart = (): AppThunk => async (dispatch, state) => {
  const uuid = state.uuid
  if (!uuid) return
  await cart.emptyCart(uuid)
  dispatch({type: 'EMPTY_CART'})
}
